<template>
     <div :key="journal.ID" class="ml-0">
        <p v-if="currentIssues" class="text-subtitle-1 my-3 font-weight-medium font-weight-black">
            Current issue: vol. {{ currentIssues.volume }} no. {{ currentIssues.number }}, {{currentIssues.year}}
        </p>
        <div v-if="currentIssues">
            <div v-for="(item,index) in currentIssues.articles" :key="index"  class="body-2 py-1">
                <p class="ma-0 pt-0 pb-1">{{ item.AUTHORS }}:</p>
                <p class="ma-0 pt-0 pb-1">
                    <a :href="getHref(item.DOI)" class="text-decoration-underline pointer nb">{{ item.TITLE}}</a>
                </p>
                <p class="ma-0 pt-0 pb-1">
                    Published online on<span v-html="item.published" class="px-1"></span>as doi:
                    <a :href="getHref(item.DOI)"  class="text-decoration-underline pointer nb">{{ item.DOI}}</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import router from '../../../router';
export default {
    data() {
        return{
            currentIssues:null,
        }
    },
    created() {
        this.getcurrentIssues();
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
    methods: {
        async getcurrentIssues(){
            try{
                const res = await axios.get('/index.php/api/library/journals/current/'+this.$route.params.journal_id );
                if(res){
                    this.currentIssues = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
        getHref(doi){
            return 'https://articles.math.cas.cz/'+doi;
        }
    },
}
</script>
<style scoped>
.nb{
    color:rgb(37,38,151) !important ;
}
</style>
